export const getSapData = (rows, options) => {

  switch (options.area) {
    case 'calculation':
      return getCalculationData(rows, options);
    case 'amortization':
      return getAmortizationData(rows, options);
  }
};

const getCalculationData = (rows, { department, periods, shift }) => {
  if (shift)
    rows.shift();

  return {
    rows: rows.filter(row => {
      if (!row['I'] || !row['F'] || !row['C']) return false;

      if (department.kod_direct !== -1) {
        const field = !row['F'].includes('не присвоено') && 'F' || 'I';
        const mvpCode = row[field].substring(5, 9);
        if (mvpCode !== department.mvp_code)
          return false;
      }

      let period = row['C'].substring(1, 8).split('.');
      period = Number(`${period[1]}.${period[0]}`);

      return periods.includes(`${period}`);
    })
  }
}

const getAmortizationData = (rows, { shift, codes}) => {
  const headers = rows[0], columns = {};

  if (shift)
    rows.shift();

  for (const [key, value] of Object.entries(headers)) {
    if (value === 'МВП')
      columns.mvp = key;
    else if (value === 'Основное средство')
      columns.mainAsset = key;
    else if (value === 'Инвентарный номер')
      columns.inventoryNumber = key;
    else if (value === 'Субномер')
      columns.subnumber = key;
    else if (value === 'Дата проводки поступления')
      columns.dateReceiptPosting = key;
    else if (value === 'Дата списания')
      columns.dateWriteOf = key;
    else if (value.includes('Группа амортизации'))
      columns.groupAmortization = key;
    else if (value === 'МВЗ')
      columns.mvz = key;
  }

  if (!columns.mvz) {
    throw new Error('В файле отсутствует колонка "МВЗ"!');
  }

  return {
    options: { headers },
    rows : rows.filter(row => {
      if (!row[columns.mvp] || !row[columns.mainAsset] || !row[columns.inventoryNumber] || !row[columns.groupAmortization]) return false;

      if (codes) {
        const mvpCode = row[columns.mvp];
        return codes.includes(mvpCode);
      }

      return true;
    })
  }
}
